import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-type-donation-document.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsTypeDonationDocumentDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consTypeDonationDocumentEntity = useAppSelector(state => state.consTypeDonationDocument.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consTypeDonationDocumentDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.detail.title">ConsTypeDonationDocument</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consTypeDonationDocumentEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.code">Code</Translate>
            </span>
          </dt>
          <dd>{consTypeDonationDocumentEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.name">Name</Translate>
            </span>
          </dt>
          <dd>{consTypeDonationDocumentEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.nameAr"> Name Ar</Translate>
            </span>
          </dt>
          <dd>{consTypeDonationDocumentEntity.nameAr}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.nameEn"> Name En</Translate>
            </span>
          </dt>
          <dd>{consTypeDonationDocumentEntity.nameEn}</dd>
          <dt>
            <span id="folderName">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.folderName">Folder Name</Translate>
            </span>
          </dt>
          <dd>{consTypeDonationDocumentEntity.folderName}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonationDocument.status">Status</Translate>
            </span>
          </dt>
          <dd>{consTypeDonationDocumentEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-type-donation-document" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-type-donation-document/${consTypeDonationDocumentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsTypeDonationDocumentDetail;
